import useSecurityKey from './useSecurityKey';

export default function useGlobalUrl() {
  const { getKey } = useSecurityKey();
  const key = getKey();

  let baseUrl;
  if (window.location.hostname === 'localhost' && window.location.port === '8080') {
    baseUrl = 'http://localhost:3128';
  } else {
    baseUrl = 'https://cms.peggenterprises.net';
  }

  // const graphqlUrl = `https://cms.peggenterprises.net/data/graphql`;
  const graphqlUrl = `${baseUrl}/data/graphql?key=${key}`;
  const leadFileUrl = `${baseUrl}/lead-files`;
  const contactFileUrl = `${baseUrl}/contact-files`;
  const emailUrl = `${baseUrl}/send-email?key=${key}`;
  const rootUrl = `${baseUrl}`;

  return {
    graphqlUrl,
    leadFileUrl,
    contactFileUrl,
    rootUrl,
    emailUrl,
  };
}
